import { createRouter, createWebHistory } from "vue-router";
import { desktopRouter } from "@/router/desktop";
import { mobileRouter } from "@/router/mobile";
import { useAuth, useOidcStore } from "vue3-oidc";
import { globalEnv } from "@/constants";

let routes = desktopRouter;

if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
  routes = mobileRouter;
}

const router = createRouter({
  history: createWebHistory(globalEnv.baseUrl),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const { signinRedirect } = useAuth();
  const oidcStore = useOidcStore();
  const userManager = oidcStore.state.value?.userManager;
  let user = oidcStore.state.value.user;
  // If user is not set, try to get it from the userManager
  if (!user && userManager) {
    user = await userManager.getUser();
    if (user) {
      oidcStore.actions.value.setUser(user);
    }
  }
  if (!user && to.name !== "oidcCallback") {
    signinRedirect({ state: { redirectPath: to.fullPath } });
    return;
  }

  next();
});

export default router;
